















































import {Prop, Watch} from "vue-property-decorator";
	import {Component, Vue} from '@/shared/component';

	import {storeLivraisonsTotaux, LivraisonFilter} from '@/stores/modules/livraison';
	
	import CrudList from '@/components/Crud/List.vue';
	import TableHead from '@/components/Paginate/TableHead.vue';
	import TableCell from '@/components/Paginate/TableCell.vue';
	import Checked from '@/components/Checked.vue';
	import {Stored} from "vue-stored-prop-decorator/index";
	import {WatchObjectProperties} from "@/shared/decorator";
	import {FournisseurFilter} from "@/stores/modules/fournisseur"
	import { DxChart, DxSeries, DxExport } from 'devextreme-vue/chart';
	
	@Component({
		components: {
			CrudList,
			TableHead,
			TableCell,
			Checked,
			DxChart,
			DxSeries,
			DxExport,
		}
	})
	export default class CrudLivraisonListTotauxLivraisons extends Vue {
		
		@Prop({type: Boolean, default: true  }) private paginate;
		@Prop({type: Boolean, default: false }) private dense;
		@Stored(() => storeLivraisonsTotaux) private filters!: LivraisonFilter;
		
		private storeLivraisonsTotaux = storeLivraisonsTotaux;

		private headers = [];
		private search = '';

		@WatchObjectProperties('filters', LivraisonFilter)
		private filterWatcher(): void {
			var dest = { text: 'Destination', value: 'destination' }
			var essence = { text: 'Essence', value: 'essenceAchat.boisType' }
			var longueur = { text: 'Longueur', value: 'essenceAchat.longueursAchat' }
			var volume = { text: 'Volume total', value: 'volume' }
			this.headers = [];
			if (this.filters.totalParDepot) {
				this.headers.push(dest)
			}
			if (this.filters.totalParBoisType) {
				this.headers.push(essence)
			}
			if (this.filters.totalParLongueur) {
				this.headers.push(longueur)
			}
			this.headers.push(volume)
			console.log("echo")
		}
	}
